<template>
  <main>
    <div class="form-section" v-if="showForm">
        <h5>Post a reply</h5>
        <CommentForm :comment="comment" />
    </div>

    <ThreadComments v-for="(reply, index) in $attrs.twoReplies" v-show="!hide" :key="index" :reply="reply" :showThreadComments="showThreadComments" />
    <ThreadComments v-for="reply in replies" v-show="hide" :key="reply.id" :reply="reply" :showThreadComments="showThreadComments" />

    <a class="read-more" v-if="showThreadComments" v-show="($attrs.twoReplies.length === 2 && $parent.replies.length > 2) && !showReadMore" @click="readMore">Read more replies...</a>
    <div class="loading" v-show="!hide" v-if="!loaded">
        <loading-spinner :style="{ position: 'static' }"></loading-spinner>
    </div>
  </main>
</template>

<script>
import ThreadComments from './ThreadComments.vue';
import CommentForm from './CommentForm.vue';

export default {

    data() {
        return {
            hide: false,
            loaded: true,
            replies: [], 
            showReadMore: false
        }
    },
    components: {
        ThreadComments,
        CommentForm
    },
    props: {
        comment: Object,
        showForm: Boolean,
        showThreadComments: Boolean
    },
    computed: {
        threadComments() {
            return this.$store.state.threadComments;
        }
    },
    methods: {
        readMore() {
            const commentsDepth = this.$wpoptions.thread_comments_depth;
            const comment_order = this.$wpoptions.comment_order;
            this.loaded = false;
                    
            this.$store.dispatch('getThreadComments', { parent_exclude: 0, order: comment_order }).then(res => {

                this.showReadMore = !this.showReadMore;

                let filteredData = res.data.filter(reply => reply.parent === this.comment.id);
                this.hide = !this.hide;
                this.replies = filteredData;
            })
        }
    }

}
</script>

<style>

</style>